<template>
  <div class="aboutUs">
    <div class="bannerImg">
      <img :src="bgtop" class="video-img">
      <div class="img-content">
        <h3>赋能万千学子的人生规划</h3>
        <p>峰学未来基于雄厚的师资力量，致力于为万千学子做好升学规划，帮助每一位学子走好迈向成功路的第一步。</p>
      </div>
    </div>
    <div class="main-content">
      <div class="about-content">
        <div class="company-content">
          <div class="company-left">
            <div class="title">ABOUT US</div>
            <div class="name">峰学未来教育科技有限公司</div>
            <div class="line"></div>
          </div>
          <div class="company-right">
            <p>峰学未来致力于打造一体化的人才培养及教育生态平台，打通人才培养、升学规划及优质就业的绿色通道。</p>
            <p>峰学未来由名师张雪峰于2021年一手创立，集团总部坐落在中国最强园区：苏州工业园区。
              公司目前拥有升学规划指导、素质能力拓展、图书研发策划、实习就业、研学教育、直播电商等多个业务板块，
              学员客户遍布北京、上海、江苏、广东、山东、辽宁等全国30+省级行政区域。</p>
            <p>峰学未来成功搭建了全国高考志愿填报智能在线应用平台——峰学未来APP及院校专业信息数据库，
              结合学员兴趣、性格和职业能力倾向测评系统，构建互联网+高考志愿智能规划与升学指导系统，
              同时匹配线下高考志愿填报系统与学业规划专家一对一人工指导服务，
              为万千高中生和家长解决新高考选科、高中学业规划、志愿填报、大学学业规划、实习就业等各方面问题。</p>
          </div>
        </div>
<!--        <div class="boss-info">-->
<!--          <img :src="bossImg">-->
<!--          <div class="boss-content">-->
<!--            <h3>张雪峰</h3>-->
<!--            <span>峰学未来创始人兼CEO</span>-->
<!--            <p>峰学未来创始人兼CEO，北京大学光华管理学院EMBA，全网知名教育博主，有十多年中国高校院校专业规划领域研究及从业经验，-->
<!--              因其风趣幽默又干货满满的讲座和直播风格深受全国广大学生和家长喜爱，吸引众多粉丝关注，目前拥有全网粉丝5000万以上。-->
<!--              张雪峰老师早年从事考研规划指导时深刻洞察了学生在大学院校专业选择时的盲目冲动会给将来考研及就业带来不小的问题，-->
<!--              因此创办了峰学未来，希望能通过我们的努力让学生尽早树立职业规划意识，在高中选科、志愿填报时不再迷茫。</p>-->
<!--          </div>-->
<!--        </div>-->
      </div>
      <div class="team-content">
        <div class="title">
          <h2>团队风采</h2>
          <p>我们是一个团结友爱的团队，在这里，各种福利少不了。比如秋天的第一杯奶茶、冬日的第一顿火锅…</p>
        </div>
        <div class="team-img">
          <!--<div class="left-img">
            <img :src="teamImg1" class="img1"/>
          </div>-->
          <div class="right-img">
            <div class="image-scroll" ref="scrollContainer">
              <div class="image-list top-img" :style="{ transform: `translateX(${-scrollPosition}px)` }">
                <img :src="item.url" v-for="(item,index) in imageList1" :key="index"/>
              </div>
            </div>
            <div class="image-scroll" ref="scrollContainer">
              <div class="image-list bottom-img" :style="{ transform: `translateX(${-scrollPosition}px)` }">
                <img :src="item.url" v-for="(item,index) in imageList2" :key="index"/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!--<someComponent></someComponent>-->
</template>

<script>
import aboutUs from "@/assets/img/aboutUs.jpg";
import bossImg from '@/assets/img/bossImg.jpg';
import teamImg1 from "@/assets/img/teamImg1.jpg";
import teamImg2 from "@/assets/img/teamImg2.jpg";
import teamImg3 from "@/assets/img/teamImg3.jpg";
import teamImg4 from "@/assets/img/teamImg4.jpg";
import teamImg5 from "@/assets/img/teamImg5.jpg";
import teamImg6 from "@/assets/img/teamImg6.jpg";
import teamImg7 from "@/assets/img/teamImg7.jpg";
import teamImg8 from "@/assets/img/teamImg8.jpg";
import teamImg9 from "@/assets/img/teamImg9.jpg";
import teamImg10 from "@/assets/img/teamImg10.jpg";
import teamImg11 from "@/assets/img/teamImg11.jpg";
import teamImg12 from "@/assets/img/teamImg12.jpg";
import teamImg13 from "@/assets/img/teamImg13.jpg";
import teamImg14 from "@/assets/img/teamImg14.jpg";
import teamImg15 from "@/assets/img/teamImg15.jpg";
import teamImg16 from "@/assets/img/teamImg16.jpg";
import teamImg17 from "@/assets/img/teamImg17.jpg";
import teamImg18 from "@/assets/img/teamImg18.jpg";
import teamImg19 from "@/assets/img/teamImg19.jpg";
import teamImg20 from "@/assets/img/teamImg20.jpg";
import teamImg21 from "@/assets/img/teamImg21.jpg";
import teamImg22 from "@/assets/img/teamImg22.jpg";
import teamImg23 from "@/assets/img/teamImg23.jpg";
import teamImg24 from "@/assets/img/teamImg24.jpg";
import teamImg25 from "@/assets/img/teamImg25.jpg";
import teamImg26 from "@/assets/img/teamImg26.jpg";
import teamImg27 from "@/assets/img/teamImg27.jpg";
import teamImg28 from "@/assets/img/teamImg28.jpg";
import teamImg29 from "@/assets/img/teamImg29.jpg";
import teamImg30 from "@/assets/img/teamImg30.jpg";
import teamImg31 from "@/assets/img/teamImg31.jpg";
import teamImg32 from "@/assets/img/teamImg32.jpg";

export default {
  name: "",
  data() {
    return {
      //bgtop:'https://oss.fxwljy.com/attach/file1705397879910.png',
      bgtop:aboutUs,
      bossImg:bossImg,
      imageList1:[
        {url:teamImg1},
        {url:teamImg2},
        {url:teamImg3},
        {url:teamImg4},
        {url:teamImg5},
        {url:teamImg6},
        {url:teamImg7},
        {url:teamImg8},
        {url:teamImg9},
        {url:teamImg10},
        {url:teamImg11},
        {url:teamImg12},
        {url:teamImg13},
        {url:teamImg14},
        {url:teamImg15},
        {url:teamImg16},
        {url:teamImg17},
        {url:teamImg18},
      ],
      newImageList1:[
        {url:teamImg1},
        {url:teamImg2},
        {url:teamImg3},
        {url:teamImg4},
        {url:teamImg5},
        {url:teamImg6},
        {url:teamImg7},
        {url:teamImg8},
        {url:teamImg9},
        {url:teamImg10},
        {url:teamImg11},
        {url:teamImg12},
        {url:teamImg13},
        {url:teamImg14},
        {url:teamImg15},
        {url:teamImg16},
        {url:teamImg17},
        {url:teamImg18},
      ],
      imageList2:[
        {url:teamImg19},
        {url:teamImg20},
        {url:teamImg21},
        {url:teamImg22},
        {url:teamImg23},
        {url:teamImg24},
        {url:teamImg25},
        {url:teamImg26},
        {url:teamImg27},
        {url:teamImg28},
        {url:teamImg29},
        {url:teamImg30},
        {url:teamImg31},
        {url:teamImg32},
      ],
      newImageList2:[
        {url:teamImg19},
        {url:teamImg20},
        {url:teamImg21},
        {url:teamImg22},
        {url:teamImg23},
        {url:teamImg24},
        {url:teamImg25},
        {url:teamImg26},
        {url:teamImg27},
        {url:teamImg28},
        {url:teamImg29},
        {url:teamImg30},
        {url:teamImg31},
        {url:teamImg32},
      ],
      scrollPosition:0,
      isLoading:false,
      autoScrollInterval: null,
    }
  },
  component: {
    //someComponent
  },
  mounted() {
    this.$nextTick(() => {
      this.startAutoScroll();
    });
    /*this.$refs.scrollContainer.addEventListener("scroll", this.checkScroll);*/
  },
  beforeDestroy() {
    // Remove the scroll event listener when the component is destroyed
    this.$refs.scrollContainer.removeEventListener("scroll", this.checkScroll);
  },
  methods:{
    startAutoScroll(){
      this.autoScrollInterval = setInterval(() => {
        this.scrollPosition += 1; // Adjust the speed of scrolling as needed
        const containers = this.$refs.scrollContainer;
        if (!containers) return;
        // Check if the user has reached the end of the images, reset to the beginning
        (Array.isArray(containers) ? containers : [containers]).forEach(container => {
          if (this.scrollPosition >= container.scrollWidth) {
            this.loadMoreImages();
          }
        });
      }, 20);
    },
    checkScroll(){
      const container = this.$refs.scrollContainer;
      const threshold = container.clientWidth;
      if (container.scrollLeft + container.clientWidth >= container.scrollWidth - threshold) {
        this.loadMoreImages();
      }
    },
    loadMoreImages(){
      if (this.isLoading) return;
      this.isLoading = true;
      setTimeout(() => {
        this.imageList1 = [...this.imageList1, ...this.newImageList1];
        this.imageList2 = [...this.imageList2, ...this.newImageList2];
        this.isLoading = false;
      }, 1000); // Adjust the timeout as needed
    }
  }
}
</script>

<style lang="scss" scoped>
* {
  margin: 0;
  padding: 0;
}
a{
  text-decoration: none;
}
@font-face {
  font-family: 'letterFamily';
  src: url('https://oss.fxwljy.com/attach/file1706510091837.ttf');
}
@font-face {
  font-family: 'SourceHanSansCN';
  src: url('https://oss.fxwljy.com/attach/file1706509868982.otf');
}
@font-face {
  font-family: 'SourceHanSansCNBold';
  src: url('https://oss.fxwljy.com/attach/file1706509868791.otf');
}
.aboutUs{
  width: 100%;
  height: 100%;
  background: #FFFFFF;
  position: relative;
  overflow: hidden;
  .bannerImg{
    width: 100%;
    position: relative;
    overflow: hidden;
    img{
      object-fit: contain;
      width: 100%;
      height: 100%;
    }
    .img-content {
      position: absolute;
      left: 50%;
      top: 40%;
      transform: translateX(-50%);
      text-align: center;

      h3 {
        font-size: 40px;
        font-family: 'SourceHanSansCNBold Microsoft YaHei';
        font-weight: bold;
        color: #FFFFFF;
        line-height: 60px;
      }

      p {
        font-size: 18px;
        font-family: 'SourceHanSansCN Microsoft YaHei';
        font-weight: 400;
        color: rgba(255, 255, 255, 0.6);
        line-height: 24px;
        margin-top: 30px;
      }
    }
  }
  .main-content{
    width: 100%;
    .about-content{
      width: 1200px;
      margin: 120px auto;
      .company-content{
        display: flex;
        justify-content: space-between;
        margin-bottom: 120px;
        .company-left{
          width: 360px;
          .title{
            font-size: 20px;
            font-family: 'letterFamily';
            color: rgba(0,134,255,0.6);
            line-height: 30px;
          }
          .name{
            font-size: 40px;
            font-family: 'SourceHanSansCNBold Microsoft YaHei';
            font-weight: bold;
            color: #0A0D0F;
            line-height: 60px;
            letter-spacing: 1px;
            margin-top: 170px;
            margin-bottom: 40px;
          }
          .line{
            width: 60px;
            height: 6px;
            background: #0086FF;
          }
        }
        .company-right{
          width: 760px;
          p{
            font-size: 18px;
            font-family: 'SourceHanSansCN Microsoft YaHei';
            font-weight: 400;
            color: #434649;
            line-height: 36px;
            margin-bottom: 24px;
            text-align: justify;
          }
        }
      }
      .boss-info{
        background: #F5F7FA;
        border-radius: 16px;
        display: flex;
        margin: 120px 0;
        height: 416px;
        img{
          width: 490px;
          height: 416px;
          border-radius: 16px;
        }
        .boss-content{
          padding: 30px 40px;
          h3{
            font-size: 24px;
            font-family: 'SourceHanSansCNBold Microsoft YaHei';
            font-weight: bold;
            color: #0A0D0F;
            line-height: 36px;
            margin-bottom: 12px;
          }
          span{
            font-size: 18px;
            font-family: 'SourceHanSansCN Microsoft YaHei';
            font-weight: 400;
            color: #0A0D0F;
          }
          p{
            margin-top: 24px;
            font-size: 18px;
            font-family: 'SourceHanSansCN Microsoft YaHei';
            font-weight: 400;
            color: #434649;
            line-height: 36px;
            text-align: justify;
          }
        }
      }
    }
    .team-content{
      width: 100%;
      margin: 120px 0;
      margin-bottom: 20px;
      .title{
        width: 1200px;
        margin: 0 auto;
        h2{
          font-size: 40px;
          font-family: 'SourceHanSansCNBold Microsoft YaHei';
          font-weight: bold;
          color: #0A0D0F;
          line-height: 60px;
        }
        p{
          font-size: 20px;
          font-family: 'SourceHanSansCN Microsoft YaHei';
          font-weight: 400;
          color: #909295;
          line-height: 16px;
          margin-top: 30px;
        }
      }
      .team-img{
        display: flex;
        justify-content: space-between;
        margin-top: 68px;
        height: 610px;
        .right-img{
          /*width: 4680px;*/
          /*display: flex;
          flex-direction: column; !* 设置主轴为垂直方向 *!
          justify-content: space-between; !* 在主轴居中对齐 *!
          align-items: stretch; !* 拉伸子项目到与容器高度相同 *!*/
          position: relative;
          overflow: hidden;
          .image-scroll{
            width: 100%;
            height: 300px; /* Adjust the height of the scroll container as needed */
            white-space: nowrap;
          }
          .image-list {
            display: inline-flex;
          }
          .top-img{
            margin-bottom: 5px;
            display: flex;
            justify-content: space-between;
            /*animation: move 40s linear 1s infinite;*/
            white-space: nowrap;
            img{
              margin-right: 10px;
              width: 300px;
              height: 300px;
              transition: transform 0.5s ease-in-out;
            }
          }
          .bottom-img{
            display: flex;
            justify-content: space-between;
            /*animation: move 40s linear 1s infinite;*/
            margin-top: 10px;
            margin-left: 150px;
            img{
              margin-right: 10px;
              width: 300px;
              height: 300px;
            }

          }

          @keyframes move {
            /*from {
              transform: translateX(0);
            }

            to {
              transform: translateX(-2230px);
            }*/
            0%{
              transform: translateX(0);
            }
            100%{
              transform: translateX(-1800px);
            }
          }
        }
      }
    }
  }
}

</style>